module.exports = __webpack_public_path__ + "media/icons/upload-b714c524.png";